import { defineComponent as _defineComponent } from 'vue'
import { computed, watch } from "vue"

interface Props {
    totalItems: number
    pageSize: number
    currentPage: number
    maxVisible?: number
    pageSizeOptions?: number[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'paginator',
  props: {
    totalItems: { type: Number, required: true },
    pageSize: { type: Number, required: true },
    currentPage: { type: Number, required: true },
    maxVisible: { type: Number, required: false, default: 5 },
    pageSizeOptions: { type: Array, required: false, default: () => [10, 25, 50, 100] }
  },
  emits: ["update:currentPage", "update:pageSize"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const totalPages = computed(() =>
    Math.max(1, Math.ceil(props.totalItems / props.pageSize))
)

const startPage = computed(() => {
    const half = Math.floor(props.maxVisible / 2)
    return Math.max(1, props.currentPage - half)
})

const endPage = computed(() => {
    return Math.min(
        totalPages.value,
        startPage.value + props.maxVisible - 1
    )
})

const visiblePages = computed(() => {
    const pages: number[] = []
    for (let i = startPage.value; i <= endPage.value; i++) {
        pages.push(i)
    }
    return pages
})

watch(totalPages, (newTotal) => {
    if (props.currentPage > newTotal) {
        emit("update:currentPage", 1)
    }
})

function changePage(page: number) {
    if (page < 1 || page > totalPages.value) return
    emit("update:currentPage", page)
}

function onPageSizeChange(event: Event) {
    const newSize = Number((event.target as HTMLSelectElement).value)
    emit("update:pageSize", newSize)
    emit("update:currentPage", 1) // reset to first page
}

const __returned__ = { props, emit, totalPages, startPage, endPage, visiblePages, changePage, onPageSizeChange }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})